import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../../models/organization.model';

@Pipe({
  name: 'modifier'
})
export class ModifierPipe implements PipeTransform {

  transform(products: Product[], modifier: string): Product | null {
    return products.find(product => product.id === modifier) ?? null;
  }

}
